import { defineMessages } from 'react-intl';

import schema from './schema';
import Edit from './TextToSpeechEdit';
import View from './TextToSpeechView';

import iconSVG from '@plone/volto/icons/volume.svg';

defineMessages({
  textToSpeech: {
    id: 'Text to Speech',
    defaultMessage: 'Text to Speech',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.textToSpeech = {
    id: 'textToSpeech',
    title: 'Text to Speech',
    icon: iconSVG,
    group: 'text',
    view: View,
    edit: Edit,
    blockSchema: schema,
    restricted: ({ properties, block, contentType }) => {
      // Permite apenas em News Item
      if (contentType !== 'News Item') {
        return true;
      }
      // Permite apenas um bloco por página
      if (
        properties.blocks_layout?.items?.find(
          (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
        )
      ) {
        return true;
      }
      return false;
    },
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
